import { render, staticRenderFns } from "./BaseDataTile.vue?vue&type=template&id=9716d06a&scoped=true&"
import script from "./BaseDataTile.vue?vue&type=script&lang=ts&"
export * from "./BaseDataTile.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDataTile.vue?vue&type=style&index=0&id=9716d06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9716d06a",
  null
  
)

export default component.exports